import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { UserApiUsernamePasswordComponent } from "./non-oauth/userapi-username-password/userapi-username-password.component";
import { UserApiPublicPrivateKeyComponent } from "./non-oauth/userapi-public-private-key/userapi-public-private-key.component";
import { UserApiSharedOAuthComponent } from "./oauth/userapi-shared-oauth/userapi-shared-oauth.component";
import { UserApiApiEndpointWithKeysComponent } from "./non-oauth/userapi-api-endpoint-with-keys/userapi-api-endpoint-with-keys.component";
import { UserApiOAuthWithCustomUrlAndKeysComponent } from "./oauth/userapi-oauth-with-custom-url-and-keys/userapi-oauth-with-custom-url-and-keys.component";
import { UserApiOAuthComponent } from "./oauth/userapi-oauth/userapi-oauth.component";
import { SharedModule } from "../shared/shared.module";
import { UserApiSharedNonOAuthComponent } from "./non-oauth/userapi-shared-non-oauth/userapi-shared-non-oauth.component";
import { UserApiApiEndpointWithTokenComponent } from "./non-oauth/userapi-api-endpoint-with-token/userapi-api-endpoint-with-token.component";
import { UserApiOAuthWithCustomUrlComponent } from "./oauth/userapi-oauth-with-custom-url/userapi-oauth-with-custom-url.component";
import { UserapiRabobankComponent } from "./non-oauth/userapi-rabobank/userapi-rabobank.component";
import { UserApiSingleKeyComponent } from "./non-oauth/userapi-single-key/userapi-single-key.component";
import { UserApiAfasComponent } from "./non-oauth/userapi-afas/userapi-afas.component";
import { UserApiTripleKeyComponent } from "./non-oauth/userapi-triple-key/userapi-triple-key.component";
import { UserApiExactOnlineComponent } from "./oauth/userapi-exactonline/userapi-exactonline.component";
import { UserApiZohoComponent } from "./oauth/userapi-zoho/userapi-zoho.component";
import { UserApiSageActiveComponent } from "./oauth/userapi-sageactive/userapi-sageactive.component";
import { FloatingLabelInput } from "../../components/FloatingLabelInput";
import { BizcuitButton } from "../../components/bizcuit/BizcuitButton";
import { InfoCard } from "../../components/InfoCard";

@NgModule({
  declarations: [
    UserApiAfasComponent,
    UserApiApiEndpointWithKeysComponent,
    UserApiApiEndpointWithTokenComponent,
    UserApiOAuthComponent,
    UserApiOAuthWithCustomUrlComponent,
    UserApiOAuthWithCustomUrlAndKeysComponent,
    UserApiPublicPrivateKeyComponent,
    UserapiRabobankComponent,
    UserApiSharedOAuthComponent,
    UserApiSharedNonOAuthComponent,
    UserApiSingleKeyComponent,
    UserApiTripleKeyComponent,
    UserApiUsernamePasswordComponent,
    UserApiExactOnlineComponent,
    UserApiZohoComponent,
    UserApiSageActiveComponent
  ],
  exports: [
    UserApiAfasComponent,
    UserApiApiEndpointWithKeysComponent,
    UserApiApiEndpointWithTokenComponent,
    UserApiOAuthComponent,
    UserApiOAuthWithCustomUrlComponent,
    UserApiOAuthWithCustomUrlAndKeysComponent,
    UserApiPublicPrivateKeyComponent,
    UserapiRabobankComponent,
    UserApiSingleKeyComponent,
    UserApiTripleKeyComponent,
    UserApiUsernamePasswordComponent,
    UserApiExactOnlineComponent,
    UserApiZohoComponent,
    UserApiSageActiveComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    FloatingLabelInput,
    BizcuitButton,
    InfoCard
  ]
})
export class UserApiModalModule {
}
